export default __webpack_public_path__ + "static/media/ladyspecta.25b8a1a4.png";